/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-10 23:12:45
 */
import router from './router'
import store from './store' // vuex
import {getCookie} from './utils/cookie'
import {getUserInfo} from "@/api/api";
import {headers} from "@/utils/util"; // 获取cookie

router.beforeEach(async(to, from, next) => {
  console.log('to:', to)
  const token = store.getters.token
  if (token) {
    try {
      const userInfoRes = await getUserInfo(headers());
      if (userInfoRes.code === 1000) {
        await store.dispatch('setToken', '')
        // 使用 URL 对象清除参数并跳转
        const url = new URL(window.location.href)
        window.location.href = url.origin
        return
      }
    } catch (error) {
      console.error('Token validation error:', error)
      await store.dispatch('setToken', '')
      // 使用 URL 对象清除参数并跳转
      const url = new URL(window.location.href)
      window.location.href = url.origin
      return
    }
  }
  const cityName = getCookie('cityName')
  const tradeId = getCookie('tradeId')
  const publishId = getCookie('publishId')
  const config = getCookie('config')
  const turnover = getCookie('turnover')
  const personList = getCookie('personList') !== 'undefined' ? JSON.parse(getCookie('personList')) : ''
  await store.dispatch('setCity', cityName || '')
  await store.dispatch('setTradeId', tradeId || '')
  await store.dispatch('setPublishId', publishId || '')
  await store.dispatch('setOnFreshConfig', config || '')
  await store.dispatch('setTurnover', turnover || 0)
  await store.dispatch('setPersonList', personList || [])
  document.title = to.meta.title
  next()
})
